import './slider-carousel.scss';
import React, { useEffect, useState } from 'react';
import ImageGenerator from '../../image-generator/image-generator';
import { Link }       from 'react-router-dom';
import Slider from 'react-slick-pnth';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import play from '../../../assets/images/Group 106.svg'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const NextArrow = (props) => {
	const { className, onClick } = props;
	return (
		<div className={className} onClick={onClick}>
			<ChevronRightIcon style={{ fontSize: "30px", color: "white" }} />
		</div>
	);
};

const PrevArrow = (props) => {
	const { className, onClick } = props;
	return (
		<div className={className} onClick={onClick}>
			<ChevronLeftIcon style={{ fontSize: "30px", color: "white" }} />
		</div>
	);
};



function SliderCarousel ({ data, baseUrl }) {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 767);

		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const onFindLastItem = () =>  {
		const elementsWithClassName = document.querySelectorAll('.last-current-item');
		elementsWithClassName.forEach(element => {
			element.classList.remove('last-current-item');
		});

		const slickActiveElements = document.querySelectorAll('.slider-carousel .slick-slide.slick-active');
		const lastSlickActive = slickActiveElements[slickActiveElements.length - 2];
		if (lastSlickActive) {
			lastSlickActive.classList.add('last-current-item');
		}
	}

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		rtl: true,
		className: "center",
		// centerMode: true,
		centerPadding: "12px",
		// autoplay: true,
		autoplaySpeed: 8000,
		pauseOnHover: true,
		adaptiveHeight: true,
		initialSlide: 0,
		currentSlide: 0,
		nextArrow: <PrevArrow className="slick-arrow slick-next"/>,
		prevArrow: <NextArrow className="slick-arrow slick-prev"/>,
		onReInit: onFindLastItem,
		afterChange: onFindLastItem,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 0,
					currentSlide: 0,
					arrows: false,
					centerMode: false
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 0,
					currentSlide: 0,
					rtl: true,
					arrows: false,
					centerMode: false
				},
			},
		],
	};

	// if (isMobile) {
	// 	// اگر در حالت موبایل هستیم، تنظیمات را تغییر دهید
	// 	settings.slidesToShow = 1;
	// 	settings.slidesToScroll = 1;
	// 	settings.centerMode = false;
	// }



	const sliderData = data.programs || data.objects

	return (
		<>
			{
				sliderData && sliderData.length > 0 && (
					<div className="slider-carousel">
						<div className="slider-container">
							<Slider {...settings}>
								{sliderData.map((item, index) => (
									<Link className='play' to={`/${baseUrl}/${item.programId || item.id}`}>
										<div className='gradient-overly' key={index}>
											<Link className='play' to={`/${baseUrl}/${item.programId || item.id}`}>
												<ImageGenerator src={play} />
											</Link>

											<ImageGenerator src={item?.image}
															isLazy={false}
															name={''} />
											<div className='movie-info'>
												<div>
													<div className='title'>{item?.title}</div>
													{/*<div className='sub-title'>{item?.englishTitle}</div>*/}
												</div>
											</div>
										</div>
									</Link>
								))}
							</Slider>
						</div>
					</div>
				)
			}
		</>
	);
}

export default SliderCarousel;
